import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import React from "react";
import { 
  LayoutDashboard, 
  AlertTriangle, 
  ClipboardList, 
  Rocket, 
  Repeat, 
  Brain, 
  Shield, 
  BarChart3,
  Activity,
  Gauge,
  LineChart
} from "lucide-react";
import { cn } from "@/lib/utils";

interface DashboardTabsProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  children: React.ReactNode;
}

export function DashboardTabs({
  activeTab,
  onTabChange,
  children
}: DashboardTabsProps) {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="space-y-6">
      <div className="overflow-x-auto">
        <TabsList className="h-16 w-full flex flex-wrap lg:flex-nowrap justify-start px-2 gap-1 bg-transparent">
          <TabsTrigger 
            value="overview" 
            className={cn(
              "flex-shrink-0 text-sm font-medium px-4 py-2.5 rounded-lg",
              "data-[state=active]:bg-blue-50 data-[state=active]:text-blue-600",
              "hover:bg-gray-50 transition-colors duration-200"
            )}
          >
            <div className="flex items-center gap-2">
              <LayoutDashboard className="h-4 w-4" />
              <span>Executive Overview</span>
            </div>
          </TabsTrigger>

          <TabsTrigger 
            value="incidents" 
            className={cn(
              "flex-shrink-0 text-sm font-medium px-4 py-2.5 rounded-lg",
              "data-[state=active]:bg-red-50 data-[state=active]:text-red-600",
              "hover:bg-gray-50 transition-colors duration-200"
            )}
          >
            <div className="flex items-center gap-2">
              <AlertTriangle className="h-4 w-4" />
              <span>Incident Management</span>
            </div>
          </TabsTrigger>

          <TabsTrigger 
            value="catalog-tasks" 
            className={cn(
              "flex-shrink-0 text-sm font-medium px-4 py-2.5 rounded-lg",
              "data-[state=active]:bg-purple-50 data-[state=active]:text-purple-600",
              "hover:bg-gray-50 transition-colors duration-200"
            )}
          >
            <div className="flex items-center gap-2">
              <ClipboardList className="h-4 w-4" />
              <span>Service Catalog</span>
            </div>
          </TabsTrigger>

          <TabsTrigger 
            value="post-deployment" 
            className={cn(
              "flex-shrink-0 text-sm font-medium px-4 py-2.5 rounded-lg",
              "data-[state=active]:bg-green-50 data-[state=active]:text-green-600",
              "hover:bg-gray-50 transition-colors duration-200"
            )}
          >
            <div className="flex items-center gap-2">
              <Rocket className="h-4 w-4" />
              <span>Deployment Analytics</span>
            </div>
          </TabsTrigger>

          {/* <TabsTrigger 
            value="repetitive" 
            className={cn(
              "flex-shrink-0 text-sm font-medium px-4 py-2.5 rounded-lg",
              "data-[state=active]:bg-orange-50 data-[state=active]:text-orange-600",
              "hover:bg-gray-50 transition-colors duration-200"
            )}
          >
            <div className="flex items-center gap-2">
              <Repeat className="h-4 w-4" />
              <span>Pattern Analysis</span>
            </div>
          </TabsTrigger> */}

          {/* <TabsTrigger 
            value="reliability" 
            className={cn(
              "flex-shrink-0 text-sm font-medium px-4 py-2.5 rounded-lg",
              "data-[state=active]:bg-indigo-50 data-[state=active]:text-indigo-600",
              "hover:bg-gray-50 transition-colors duration-200"
            )}
          >
            <div className="flex items-center gap-2">
              <Shield className="h-4 w-4" />
              <span>System Health</span>
            </div>
          </TabsTrigger> */}

          <TabsTrigger 
            value="ai-analysis" 
            className={cn(
              "flex-shrink-0 text-sm font-medium px-4 py-2.5 rounded-lg",
              "data-[state=active]:bg-cyan-50 data-[state=active]:text-cyan-600",
              "hover:bg-gray-50 transition-colors duration-200"
            )}
          >
            <div className="flex items-center gap-2">
              <Brain className="h-4 w-4" />
              <span>AI Insights</span>
            </div>
          </TabsTrigger>

          <TabsTrigger 
            value="executive" 
            className={cn(
              "flex-shrink-0 text-sm font-medium px-4 py-2.5 rounded-lg",
              "data-[state=active]:bg-gray-50 data-[state=active]:text-gray-600",
              "hover:bg-gray-50 transition-colors duration-200"
            )}
          >
           {/* <div className="flex items-center gap-2">
              <LineChart className="h-4 w-4" />
              <span>Executive Metrics</span>
            </div>  */}
          </TabsTrigger>
        </TabsList>
      </div>
      <div className="mt-2">
        {children}
      </div>
    </Tabs> 
  );
}
